var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStdErrorOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8444 12.5007H1.1566C0.860357 12.5007 0.734518 12.279 0.703008 12.2111C0.671498 12.1431 0.583548 11.9039 0.774898 11.6777L9.61879 1.22586C9.71539 1.1117 9.85095 1.04883 10.0005 1.04883C10.15 1.04883 10.2856 1.1117 10.3822 1.22586L19.2261 11.6777C19.4174 11.9039 19.3295 12.1431 19.298 12.2111C19.2665 12.279 19.1406 12.5007 18.8444 12.5007Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.54883L1.15622 12.0007C1.15622 12.0007 1.15622 12.0007 1.15622 12.0007H18.844C18.844 12.0007 18.844 12.0007 18.844 12.0007L10.0017 1.54898C10.0015 1.54894 10.001 1.54883 10.0001 1.54883ZM10.0001 0.548828C10.2819 0.548828 10.5638 0.666848 10.7635 0.902888L19.6074 11.3548C20.1573 12.0047 19.6954 13.0007 18.844 13.0007H1.15622C0.304855 13.0007 -0.157096 12.0047 0.392833 11.3548L9.23672 0.902888C9.43645 0.666848 9.71828 0.548828 10.0001 0.548828Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.11328V10.3763",
    stroke: "#AECDFC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 5.34895C10.7513 5.34895 11.3607 4.73961 11.3607 3.98795C11.3607 3.23629 10.7513 2.62695 9.99967 2.62695C9.24801 2.62695 8.63867 3.23629 8.63867 3.98795C8.63867 4.73961 9.24801 5.34895 9.99967 5.34895Z",
    fill: "#AECDFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 4.84895C10.4752 4.84895 10.8607 4.46347 10.8607 3.98795C10.8607 3.51244 10.4752 3.12695 9.99967 3.12695C9.52415 3.12695 9.13867 3.51244 9.13867 3.98795C9.13867 4.46347 9.52415 4.84895 9.99967 4.84895Z",
    stroke: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStdErrorOperationIcon);
export default __webpack_public_path__ + "static/media/StdErrorOperationIcon.70c91e86249ebecd1206df85ed518922.svg";
export { ForwardRef as ReactComponent };